<template>
  <tr>
    <td>{{ socio.persona.nombre }}</td>
    <td>{{ socio.persona.apellido }}</td>
    <td>{{ socio.persona.email }}</td>
    <td>{{ socio.persona.celular }}</td>
    <td>{{ socio.es_alumno_mentor_de.nombre }} {{ socio.es_alumno_mentor_de.apellido }}</td>
    <td><router-link :to="`/datos-inscripcion-examen/${socio.examenes_inscripcion_id}`" class="boton_direccion boton_editar boton_ver_info">Ver Info</router-link></td>
  </tr>
</template>

<script>
// import comerciosService from '../services/comercios'
// import store from './../store'
// import { PATH_IMG } from '../constants'
export default {
  name: 'SociosListaItem',
  props: ['socio'],
  data: function () {
    return {
      // store
    }
  },
  methods: {
    dotsCadaTres (dni) {
      if (dni == null) {
        return null
      }
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>

<style>

</style>
